import { Injectable } from '@angular/core';

@Injectable()
export class ReasonsService {
  constructor() {}

  hasPreferences(reason): boolean {
    return reason.allowTimePreference || reason.allowSelectHcp || (reason.visitReasonType && reason.visitReasonType !== 'nothing');
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/services/reasons.service.ts